import { useProductData } from "@/src/hooks/useProductData";
import { isNil } from "lodash";
import { useEffect, useState } from "react";
import { TableProps } from "@/src/components/Table/types";
import {
  DETAILS_TAB_HEADER_DETAILS,
  DETAILS_TAB_HEADER_VALUE,
} from "./components/TokenProperties/helpers";

export const useProductDetailsTabTableData = (productName: string) => {
  const { productData, isLoading } = useProductData(productName);
  const [detailsTableRowsData, setDetailsTableRowsData] =
    useState<TableProps["rows"]>();

  useEffect(() => {
    if (!isLoading && productData !== undefined) {
      const detailsTabData = productData?.tabs?.detailsTab;

      if (!isNil(detailsTabData)) {
        const { detailRowCollection } = detailsTabData;

        const formattedDetailRows = detailRowCollection?.items.map((row) => {
          return [
            { key: DETAILS_TAB_HEADER_DETAILS, value: row?.key },
            { key: DETAILS_TAB_HEADER_VALUE, value: row?.value },
          ];
        });

        const smartContractRow = [
          {
            key: DETAILS_TAB_HEADER_DETAILS,
            value: detailsTabData.smartContractTitle ?? "",
          },
          {
            key: DETAILS_TAB_HEADER_VALUE,
            value: detailsTabData?.smartContractLink?.text ?? "",
            link: detailsTabData?.smartContractLink?.url ?? "",
            highlightValue: true,
          },
        ];

        const tableRowsData = [
          smartContractRow,
          ...(formattedDetailRows as []), // TODO: update values from API after we have access
        ];

        setDetailsTableRowsData(tableRowsData);
      }
    }
  }, [isLoading, productData]);

  return detailsTableRowsData;
};
